
import './index.css'; // Import the CSS file


// Header component
const Header = () => {
    return (
        <header className="header">
            <div className="email">
                <i className="fas fa-envelope"></i>
                <span >lbnmd320@gmail.com</span>
            </div>
            <div className="text-lg font-semibold header1">Lions Business Network-Multiple District 320</div>
            <a href="#" className="whatsapp-btn">Whatsapp</a>
        </header>
    );
};


export default Header